import Vue from 'vue';
import Router from 'vue-router';
import store from '@/vuex/store';

import SessionRoutes from './modules/session';
import InfoRoutes from './modules/info';
import NewsRoutes from './modules/news';
import transportRoutes from './modules/transport';
import benefitsRoutes from './modules/benefits';
import blogRoutes from './modules/blog';
import couponRoutes from './modules/coupons';
import t4iRoutes from './modules/t4i';
import ecadiaRoutes from './modules/ecadia';
import rhAssessorRoutes from "./modules/rhAssessor";
import menuRoutes from './modules/menu';
import conductRoutes from './modules/conduct';
import calendarRoutes from './modules/calendar';
import ideasRoutes from './modules/ideas';
import careRoutes from './modules/care';
import legalRoutes from './modules/legal';
import appsRoutes from './modules/apps';
import userRoutes from './modules/users';
import errorsRoutes from './modules/error';
import surveysRoutes from './modules/surveys'; // Containers
import interactiveMapRoutes from './modules/interactiveMap';
import lostItemsRoutes from './modules/lostItems';
import eventsRoutes from './modules/events';
import messengerServicesRoutes from './modules/messengerServices';
import serviceLineRoutes from './modules/serviceLine';
import reportPhotosRoutes from './modules/reportPhotos';
import synctoolRoutes from './modules/synctool';
import screenshotsRoutes from './modules/screenshots';
import metricsRoutes from './modules/metrics';
import keyUserRoutes from './modules/keyuser';
import qrAcessRoutes from './modules/qrAccess';
import filesAndLinksRoutes from './modules/filesAndLinks';
import mobilityRoutes from './modules/mobilityOnDemand'
import bookingTransport from './modules/bookingTransport'
import openToMove from './modules/openToMove'
import MobileStiva from './modules/MobileStiva'
import integrityComplianceRoutes from './modules/integrityCompliance';
import diagnosticRoutes from './modules/diagnostic';
import strategyRoutes from './modules/strategy';
import compensationsRoutes from './modules/compensations';
import burdenFile from './modules/burdenFile';
import synchronizationRoutes from './modules/synchronization';
// Containers
const DefaultContainer = () =>
  import( /* webpackChunkName: 'Default' */ '@/containers/DefaultContainer');

// Views
const Dashboard = () =>
  import( /* webpackChunkName: 'Dashboard' */ '@/views/Dashboard');
const MapComp = () => import( /* webpackChunkName: 'Map' */ '@/views/map/Map');

Vue.use(Router);

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '/tarjeta-presentacion/:id',
      name: 'tarjeta',
      component: () =>
        import(
          /* webpackChunkName: "surveys" */ "../views/business_card/BusinessCard.vue"
        )
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [{
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      ...InfoRoutes,
      ...NewsRoutes,
      {
        path: 'map',
        name: 'Map',
        component: MapComp,
        children: [
          ...transportRoutes,
          ...benefitsRoutes,
          ...interactiveMapRoutes
        ]
      },
      ...blogRoutes,
      ...couponRoutes,
      ...t4iRoutes,
      ...ecadiaRoutes,
      ...rhAssessorRoutes,
      ...menuRoutes,
      ...conductRoutes,
      ...calendarRoutes,
      ...ideasRoutes,
      ...careRoutes,
      ...legalRoutes,
      ...appsRoutes,
      ...userRoutes,
      ...surveysRoutes,
      ...lostItemsRoutes,
      ...eventsRoutes,
      ...messengerServicesRoutes,
      ...serviceLineRoutes,
      ...reportPhotosRoutes,
      ...synctoolRoutes,
      ...screenshotsRoutes,
      ...metricsRoutes,
      ...keyUserRoutes,
      ...qrAcessRoutes,
      ...filesAndLinksRoutes,
      ...mobilityRoutes,
      ...bookingTransport,
      ...openToMove,
      ...MobileStiva,
      ...integrityComplianceRoutes,
      ...diagnosticRoutes,
      ...strategyRoutes,
      ...compensationsRoutes,
      ...burdenFile,
      ...synchronizationRoutes
      ]
    },
    ...errorsRoutes,
    ...SessionRoutes
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name != "tarjeta") {
    const errorData = {};
    let routeExist = to.matched.some(record => record);
    if (routeExist) {

      if (to.meta.isPublic) {
        console.log('check this block')
        if (store.getters['session/isAuthenticated']) {
          if (to.name === 'Error') {
            next();
          }
          else {
            next({
              name: from.name
            });
          }
        }
        else {
          if (to.name === 'Error') next({
            name: 'Login'
          });
          else next();
        }
      }
      else {
        if (store.getters['session/isAuthenticated']) {

          let hasAccess = store.getters['session/accessList'].find(
            path => path.name === to.name
          );
          if (hasAccess) {
            next();
          }
          else {
            errorData.status = 401;
            errorData.route_to = from.name;
            store.commit('global/SET_ERROR', errorData);
            next({
              name: 'Error'
            });
          }

        }
        else {
          errorData.status = 403;
          errorData.route_to = 'Login';
          errorData.fromSession = false;
          store.commit('global/SET_ERROR', errorData);
          next({
            name: 'Login'
          });
        }
      }
    }
    else {
      errorData.status = 404;
      errorData.route_to = from.name;
      store.commit('global/SET_ERROR', errorData);
      if (from.name === 'Login') {
        next({
          name: 'Login'
        });
      } else {
        next({
          name: 'Error'
        });
      }
    }
  } else {
    next();
  }
});

export default router;
